export const COMETCHAT_CONSTANTS = {
	APP_ID: process.env.VUE_APP_COMETCHAT_APP_ID,
	REGION: 'US',
	AUTH_KEY: process.env.VUE_APP_DEV_AUTH_KEY
}